import { call, put, takeLatest, select } from 'redux-saga/effects'
import { defineTypes } from '../../helpers'
import { reduxFetch } from '../../http/reduxFetch'
import CompanyEndpoint from '../../persistence/CompanyEndpoint'
import VerificationEndpoint from '../../persistence/VerificationEndpoint'
import { push } from 'react-router-redux'
import moment from 'moment'
import { selectors as companySelectors } from '../account'
import Alert from 'react-s-alert';

const account_create = { ...defineTypes('NEW_ACCOUNT') }

export const initialState = {
  started: false,
  loading: false,
  loaded: false,
  verified: false,
  userId: undefined,
  birthdate: moment().subtract(13, 'years')
}

export const actions = {
  createCompanyInfoForm () {
    return { type: 'CREATE_ACCOUNT_INFO' }
  },
  updateCompanyInfoForm () {
    return { type: 'UPDATE_ACCOUNT_INFO' }
  },
  updateBirthdate (birthdate) {
    return { type: 'BIRTHDATE_UPDATE', birthdate: moment(birthdate) }
  },
  setUserId (userId) {
    return { type: 'SET_USER_ID', userId: userId }
  }
}

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case account_create.REQUEST:
      return { ...state, started: true, loading: true }
    case account_create.FAILURE:
      return { ...state, loading: false, errors: action.error }
    case account_create.SUCCESS:
      return { ...state, loading: false, loaded: true, company: action.company, verified: false }
    case 'SET_USER_ID':
      return { ...state, userId: action.userId }
    case 'VERIFICATION_SUCCESS':
      return { ...state, loading: false, loaded: true, verified: true, verification: action.verification }
    case 'BIRTHDATE_UPDATE':
      return { ...state, birthdate: action.birthdate }
    default:
      return state
  }
}
export const selectors = {
  account_form: (store) => {
    return store.form.account_form
  },
  birthdate: (store) => {
    return store.account.account_info &&
      store.account.account_info.birthdate
      || store.account_information.birthdate
  },
  new_company_id: (store) => {
    return store.account_information.company.id
  },
  user_id: (store) => {
    return store.account_information.userId
  },
  errors: (store) => {
    return store.account_information.errors
  }
}

export function * VerifyAccountSaga () {
  let company_id = yield select(selectors.new_company_id)
  const verification = yield call(reduxFetch, VerificationEndpoint.verify(company_id))
  if (verification['data'] ) {
    yield put({
      type: 'VERIFICATION_SUCCESS',
      verification: verification.data,
    })
  } else {
    yield put({
      type: account_create.FAILURE,
      error: verification['errors']
    })
  }
}

export function * AccountInfoSaga (action) {
  try {
    let account_form = {}
    const form = yield select(selectors.account_form)
    account_form['company'] = form['values']
    account_form['company']['user_id'] = yield select(selectors.user_id)
    const company = yield call(reduxFetch, CompanyEndpoint.create(account_form))
    if ( company['data'] ) {
      yield put({
        type: account_create.SUCCESS,
        company: company.data,
        verified: false
      })
      yield put(push('/account_settings'))
    } else {
      yield put({
        type: account_create.FAILURE,
        error: company['errors']
      })
    }
  } catch (error) {
    yield put({ type: account_create.FAILURE, error })
  }
}

export function * UpdateAccountInfoSaga (action) {
  try {
    let account_form = {}
    const form = yield select(selectors.account_form)
    account_form['company'] = form['values']
    account_form['id'] = yield select(companySelectors.company_id)
    account_form['company']['birthdate'] = yield select(selectors.birthdate)
    const company = yield call(reduxFetch, CompanyEndpoint.updateAccountInfo(account_form, account_form['id']))

    if ( company['data'] ) {
      yield put({
        type: account_create.SUCCESS,
        company: company.data,
      })
      yield call(Alert.success, '<div>Account Updated</div>')
    } else {
      yield put({
        type: account_create.FAILURE,
        error: company['errors']
      })
    }
  } catch (error) {
    yield put({ type: account_create.FAILURE, error })
  }
}

export function * rootSaga () {
  yield takeLatest('CREATE_ACCOUNT_INFO', AccountInfoSaga)
  yield takeLatest('UPDATE_ACCOUNT_INFO', UpdateAccountInfoSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/sign_up/account_information.js